import React from 'react'
import Navbar from '../Components/Navbar'
import Slider from '../Components/Slider'
import Footer from '../Components/Footer'
import Social from '../Components/Social'

const Slides = () => {
  return (
    <>
    <Navbar/>
    <Social/>
    <Slider/>
    <Footer/>
    </>
  )
}

export default Slides